import { addToBasket, getReorderStatus } from "apis/reorderApi";
import { doCall } from "common/genericSaga";
import { all, call, put, takeEvery, takeLatest } from "redux-saga/effects";
import {
  receiveReorderRequest,
  receiveReorderStatus,
  REORDER_REQUESTED,
  REORDER_REQUEST_FAILED,
  REORDER_STATUS_REQUESTED,
  REORDER_STATUS_REQUEST_FAILED
} from "./reorderActions";

export function* doRequestReorderStatus(action, requestInfo) {
  const response = yield call(getReorderStatus, requestInfo, action.id);
  yield put(receiveReorderStatus(action.id, response));
}

export function* doRequestReorder(action, requestInfo) {
  const response = yield call(addToBasket, requestInfo, action.id);
  yield put(
    receiveReorderRequest(action.id, {
      shopUrl: response.shopUrl
    })
  );
}

export function* watchReorder() {
  yield all([takeEvery(REORDER_STATUS_REQUESTED, doCall(doRequestReorderStatus, REORDER_STATUS_REQUEST_FAILED))]);
  yield all([takeLatest(REORDER_REQUESTED, doCall(doRequestReorder, REORDER_REQUEST_FAILED))]);
}
